module.exports = __webpack_public_path__ + "img/team-main-04.e54ab0ed.png";